export const Logo = ({ size = 44 }) => (
  <img
    src="/uma-logo.png"
    alt="Uma Enterprises — Solar Sales & Solutions"
    style={{ height: size, width: "auto" }}
    className="object-contain"
    data-testid="brand-logo-image"
  />
);
